import React, {useEffect} from "react"
import DriverOrderList from "./components/DriverOrderList/DriverOrderList"
import TransitionContainer from "../../generic/wrappers/TransitionContainer"
import {useAppDispatch} from "../../../hooks/redux"
import {getOrderStatuses} from "../../../store/actions/orderActions"
import classes from "./DriverOrder.module.scss"

function DriverOrder() {

  const dispatch = useAppDispatch()

  const orderBlocks = [
    {
      title: "Новые заявки",
      block: <DriverOrderList type={"new"}/>
    },
    {
      title: "Мои заявки",
      block: <DriverOrderList type={"current"}/>
    },
    {
      title: "Завершено",
      block: <DriverOrderList type={"complete"}/>
    }
  ]

  useEffect(() => {
    dispatch(getOrderStatuses())
  }, [dispatch])

  return (
    <div className={classes.wrap}>
      <TransitionContainer withTitleBorder blocks={orderBlocks} className={classes.tabs}/>
    </div>
  )
}

export default DriverOrder